
var searchApp = angular.module('searchApp', ['infinite-scroll', 'ui.router', 'searchData', 'sharedFilters', 'angularGrid', '720kb.socialshare','configService','sharedServices']);

searchApp.config(function($interpolateProvider, $stateProvider,$locationProvider, $urlRouterProvider, $httpProvider,$compileProvider, config, EncryptedLocalStorageProvider) {
	config.token = localStorage.getItem('token');
    $stateProvider.state("home", {
			views: {
		    "body":{
		    	template:"<div ui-view></div>"
		    },
		    "dynamicHeader": {
		      templateUrl: "../../html/dynamicHeader.html",
		      controller: 'headerController',
		    },
			},
			abstract: true
    }).state("home.root", {
    	url:"",
    }).state("home.vendors", {
    	url:"/search/vendors/:keyword",
    	templateUrl: "../../html/vendorFeed.html?v=1.0.6",
    	controller: "vendorController"
    }).state("home.articles", {
    	url:"/search/article/:keyword",
    	templateUrl: "../../html/articleFeed.html?v=1.0.1",
    	controller: "articleController"
    }).state("home.photos", {
    	url:"/search/photos/:keyword",
    	templateUrl: "../../html/imageFeed.html?v=1.0.1",
    	controller: "imageController"
    });
    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
    $locationProvider.hashPrefix('!');
    $locationProvider.html5Mode(true);
    $compileProvider.debugInfoEnabled(false);
});
searchApp.controller('headerController', ['$scope', '$interval', '$state',  '$rootScope', '$timeout', '$stateParams', 'config', 'getSearchInfo', 'getVendorInfo', function($scope, $interval, $state,  $rootScope, $timeout, $stateParams, config, getSearchInfo, getVendorInfo) {
	$scope.path = {};
	$scope.headerData={};
	var value = window.location.pathname.split('/')
	$scope.path.queryString = decodeURIComponent(value[3]);
	console.log($scope.path.queryString);
	$scope.path.typeValue = value[2];
	console.log($scope.path.typeValue)
	if ($scope.path.typeValue === 'photos') {
		$scope.path.typeValue = 'image'
	}
	$rootScope.$on('$locationChangeSuccess', function() {
		console.log('statechangesuccess');
		$scope.path.typeValue = window.location.pathname.split('/')[2];
		if ($scope.path.typeValue === 'photos') {
			$scope.path.typeValue = 'image'
		}
		$scope.headerData.defaultName = $scope.path.typeValue;
		$scope.path.queryString = decodeURIComponent(window.location.pathname.split('/')[3]);
		if( $scope.headerData.defaultName == "vendors") {
			$scope.headerData.defaultName = "vendors"
			$scope.headerData.defaultName1 = "photos";
			$scope.headerData.defaultName2 = "articles";
		} else if( $scope.headerData.defaultName == "image" ) {
			$scope.headerData.defaultName = "photos"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "articles";
		} else {
			$scope.headerData.defaultName = "articles"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "photos";
		}
	});
	getVendorInfo(config.token, $scope.path.queryString, $scope.path.typeValue).success(function(data){
		//console.log("header",data,$scope.path.typeValue);
		$scope.headerData.defaultName = ($scope.path.typeValue == "" ? data.default_type : $scope.path.typeValue);
		$scope.headerData.data = data.data;
		if( $scope.headerData.defaultName == "vendors") {
			$scope.headerData.defaultName = "vendors"
			$scope.headerData.defaultName1 = "photos";
			$scope.headerData.defaultName2 = "articles";
		} else if( $scope.headerData.defaultName == "image" ) {
			$scope.headerData.defaultName = "photos"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "articles";
		} else {
			$scope.headerData.defaultName = "articles"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "photos";
		}
	})

	$(window).on('hashchange', function() {
		console.log('hashchange');

	});

	$scope.changeState = function (state) {
		$scope.headerData.defaultName = $scope.path.typeValue;
		if( $scope.headerData.defaultName == "vendors") {
			$scope.headerData.defaultName = "vendors"
			$scope.headerData.defaultName1 = "photos";
			$scope.headerData.defaultName2 = "articles";
		} else if( $scope.headerData.defaultName == "image" ) {
			$scope.headerData.defaultName = "photos"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "articles";
		} else {
			$scope.headerData.defaultName = "articles"
			$scope.headerData.defaultName1 = "vendors";
			$scope.headerData.defaultName2 = "photos";
		}
	  $state.go(state,{keyword: $scope.path.queryString});
	};
	var flag = 1;
	function $elInViewport(el) {
		var el = el.get(0);
	  var top = el.offsetTop;
	  var left = el.offsetLeft;
	  var width = el.offsetWidth;
	  var height = el.offsetHeight;

	  while(el.offsetParent) {
	    el = el.offsetParent;
	    top += el.offsetTop;
	    left += el.offsetLeft;
	  }

	  return (
	    top >= window.pageYOffset &&
	    left >= window.pageXOffset &&
	    (top + height) <= (window.pageYOffset + window.innerHeight) &&
	    (left + width) <= (window.pageXOffset + window.innerWidth)
	  );
	}
	$(window).on('scroll', function(){
		var mainheight = $('.mainFeedDiv').height();
		var sideheight = $('.sideFeedDiv').height();
		//console.log("mainFeedDiv=",mainheight,"sideFeedDiv=",sideheight);
		if(mainheight > sideheight) {
			$('.sideFeedDiv').css('height',mainheight);
		} else {
			$('.sideFeedDiv').css('height',sideheight);
		}
		if ($scope.headerData.defaultName == 'vendors' || $scope.headerData.defaultName == 'photos'){
		 if($elInViewport($(".popular")) && $elInViewport($("#test-hey"))){
	  		$('.side-bar').removeClass('fixedforimage').removeClass('absforimage');
	  	} else if(!$elInViewport($("#test-hey")) && $elInViewport($(".popular"))){
	  		$('.side-bar').removeClass('fixedforimage').removeClass('absforimage')
	  	}else if (!$elInViewport($("#test-hey")) && !$elInViewport($(".popular"))) {
	  		$('.side-bar').addClass('fixedforimage').removeClass('absforimage');
	  	} else if ($elInViewport($("#test-hey")) && !$elInViewport($(".popular"))) {
	  		$('.side-bar').removeClass('fixedforimage').addClass('absforimage');
	  	}
	  } else {
			if ($(this).scrollTop() > 135) {
		  	$('.article-feed').addClass('fixedForArticle');
		  } else {
		  	$('.article-feed').removeClass('fixedForArticle');
		  }
		}
	});
}]);

searchApp.controller('vendorController', ['$scope', '$interval', '$state',  '$rootScope', '$timeout', '$stateParams', 'config', 'getSearchInfo', 'getSearchFeed', 'getVendorInfo', function($scope, $interval, $state,  $rootScope, $timeout, $stateParams, config, getSearchInfo, getSearchFeed, getVendorInfo) {
	//$('.bodycontainer').css('min-height','0px');
	$scope.S3_URL = config.S3_URL;
	$scope.toggle = function(e) {
		var $that = $(e.target);
		if ($that.parent().children(':first-child').next().next().hasClass('closed')) {
			$that.removeClass('fa-angle-up').addClass('fa-angle-down');
			$that.parent().children(':first-child').next().next().removeClass('closed');
		} else {
			$that.removeClass('fa-angle-down').addClass('fa-angle-up');
			$that.parent().children(':first-child').next().next().addClass('closed');
		}
  };
//setInterval(function(){ alert("Hellovendor"); }, 1000);
	$scope.path = {};
	$scope.FeatureVendorData={}
	var value = window.location.pathname.split('/')
	$scope.path.queryString = decodeURIComponent(value[3]);
	$scope.path.typeValue = 'vendor';
	$scope.postArrays = new getSearchFeed(config.token, $scope.path.queryString, $scope.path.typeValue);
	//console.log("vendor",$scope.postArrays);
	getVendorInfo(config.token, $scope.path.queryString, $scope.path.typeValue).success(function(data){
 		$scope.FeatureVendorData.data = data.featured;
 		//console.log("featured",data.featured)
  });
	//setInterval(function(){ alert("Hellovendor"); }, 5000);
}]);

searchApp.filter('insertPoint', function() {
    return function(input) {
       if (input && input.length > 3) {
      nput = input.slice(0,3);
  }
      if (input % 1 == 0) {
          input = input + '.0';
      }
      return input;
    }
});

searchApp.directive('ratingColor', function() {
  return {
    restrict: 'A',
    scope: {
        'rate': '@'
    },
    templateUrl: 'ratingColor.html',
    link: function(scope, element, attrs) {
      if (1*scope.rate < 1.5) {
        scope.color = '#cb202d';
      } else if (1*scope.rate < 2.5) {
        scope.color = '#ff7800';
      } else if (1*scope.rate < 3.5) {
        scope.color = '#ffba00';
      } else if (1*scope.rate < 4.5) {
        scope.color = '#9acd32';
      } else if (1*scope.rate <= 5) {
        scope.color = '#5ba829';
      }
      if(scope.rate == 0){
        scope.color = '#4a4a4a'
      }
    }
  }
});

searchApp.controller('articleController', ['$scope', '$interval', '$state',  '$rootScope', '$timeout', '$stateParams', 'config', 'getSearchInfo', 'getSearchFeed', function($scope, $interval, $state,  $rootScope, $timeout, $stateParams, config, getSearchInfo, getSearchFeed) {
	//$('.bodycontainer').css('min-height','0px');
	$scope.toggle = function(e) {
		var $that = $(e.target);
		if ($that.parent().children(':first-child').next().next().hasClass('closed')) {
			$that.removeClass('fa-angle-up').addClass('fa-angle-down');
			$that.parent().children(':first-child').next().next().removeClass('closed');
		} else {
			$that.removeClass('fa-angle-down').addClass('fa-angle-up');
			$that.parent().children(':first-child').next().next().addClass('closed');
		}
    };
  //setInterval(function(){ alert("Helloarticle"); }, 4000);
	$scope.path = {};
	$scope.articleData={}
	var value = window.location.pathname.split('/')
	$scope.path.queryString = decodeURIComponent(value[3]);
	$scope.path.typeValue = 'article';
	$scope.postArrays = new getSearchFeed(config.token, $scope.path.queryString, $scope.path.typeValue);
	/*getVendorInfo(config.token, $scope.path.queryString, $scope.path.typeValue).success(function(data){
		//console.log("article",data);
 		$scope.articleData.data = data.data;
  	});*/
}]);

searchApp.controller('imageController', ['$scope', '$interval', '$state',  '$rootScope', '$timeout', '$stateParams', 'config', 'getSearchInfo', 'angularGridInstance', 'getSearchFeed', 'imageDetail', 'loveUnlove', 'imageShare', 'toggleLovePost', function($scope, $interval, $state,  $rootScope, $timeout, $stateParams, config, getSearchInfo, angularGridInstance, getSearchFeed, imageDetail, loveUnlove, imageShare, toggleLovePost) {
	//$('.bodycontainer').css('min-height','0px');
	$scope.searchCategories = ['Bridal lehenga Photos', 'Light Lehengas for Sangeet & Mehendi', 'Gowns & Indo Western outfits', 'Bridal Hairstyle', 'Engagement Ring', 'Stage Decor', 'Mandap Decor', 'Entrance Decor', 'Photobooth Ideas', 'Pre Wedding Shoot Ideas'];
	$scope.S3_URL = config.S3_URL;
	$scope.openLoginModal = function(e) {
		console.log('why am i here?')
		window.location.href = '/login?referrer=/';
	}
	$scope.navProfile = {};
	if (localStorage.getItem('logged_in') == 'true') {
	  $scope.navProfile.logged_in = true;
	  //console.log($scope.navProfile.logged_in,"$scope.navProfile.logged_in");
	} else {
		$scope.navProfile.logged_in = false;
	}
	$scope.toggle = function(e) {
		var $that = $(e.target);
		if ($that.parent().children(':first-child').next().next().hasClass('closed')) {
			$that.removeClass('fa-angle-up').addClass('fa-angle-down');
			$that.parent().children(':first-child').next().next().removeClass('closed');
		} else {
			$that.removeClass('fa-angle-down').addClass('fa-angle-up');
			$that.parent().children(':first-child').next().next().addClass('closed');
		}
  };
	$scope.path = {};
	$scope.imageData={}
	$scope.imageDetail={};
	var value = window.location.pathname.split('/');
	$scope.path.queryString = decodeURIComponent(value[3]);
	$scope.path.typeValue = 'image';
	// console.log($scope.path.queryString, $scope.path.typeValue);
  $scope.postArrays = new getSearchFeed(config.token, $scope.path.queryString, $scope.path.typeValue);
	//setInterval(function(){ alert($scope.path.typeValue); }, 3000);
  //console.log("outside",$scope.postArrays)

	function keypressHandler(e) {
		switch (e.keyCode) {
			case 37: //left
		    $scope.prevItem();
		    break;
			case 39: //right
		    $scope.nextItem();
		    break;
		}
	}

	$rootScope.imagesArray = $scope.postArrays.items;
	console.log($scope.postArrays.items);

	$scope.setNewImg = function(thumb){
		$scope.photodetail(thumb, thumb.$index, 'changepic');
	}

	$scope.nextItem = function(e) {
	var next_image = '';
	var currentIndex = '';
	 var image_id_arr = $rootScope.imagesArray.filter(function(data,index) {
	  if (data._source.image_id == $scope.image_id) {
	    currentIndex = index + 1;
	    next_image = $rootScope.imagesArray[index + 1];
	    return data;
	  }
	 });
	//  console.log(next_image);
	 $scope.photodetail(next_image,currentIndex,'changepic');
	}

	$scope.prevItem = function(e) {
	  var prev_image = '';
	  var currentIndex = '';
	  var image_id_arr = $rootScope.imagesArray.filter(function(data,index) {
	  if (data._source.image_id == $scope.image_id) {
	    currentIndex = index - 1;
	    prev_image = $rootScope.imagesArray[index - 1];
	    return data;
	    }
	  });
		// console.log(prev_image);
	  if (currentIndex != -1) {
	    $scope.photodetail(prev_image,currentIndex,'changepic');
	  }
	}

	$scope.photodetail = function(pic,index,changepic) {
		// console.log(pic, pic._source.image_id);
		get_before_after_images(pic._source.image_id);
		$('.wmg-photo-loader-inside').css('display','block');
		$('.wmg-photo-loader').removeClass('hide')

		$scope.imageDetailData = {}
		$scope.image_id = pic._source.image_id;

		imageDetail($scope.image_id,config.token).success(function(data) {
			// console.log(data);
			$scope.imageDetailData.image = data.data[0]
			$scope.contentUrl = data.data[0].image_url;
			$scope.loveCount = data.data[0].love_count;
			$scope.tags = data.data[0].tags && data.data[0].tags.other_tags && data.data[0].tags.other_tags.split(',');
			$scope.tagged_vendors = data.data[0].tagged_vendors.map(function(data){
				data.profile_pic_url = data.profile_pic_url.replace('%%','150');
				return data;
			});
			$scope.similar_images = data.data[0].similar_images.map(function(data) {
			  data.image_url = data.image_url.replace('%%','150');
			  return data;
			});
			var aspect_ratio = data.data[0].image_width/data.data[0].image_height;
			$scope.websiteUrl = data.data[0].tagged_vendors.length && data.data[0].tagged_vendors[0].websiteLink;


			$scope.img_height = $(window).height() - 200;
			$scope.arrow_height = parseInt($scope.img_height / 2);

			$('#imageModal').find('.left-arrow').removeClass('hide');
			$('#imageModal').find('.right-arrow').removeClass('hide');

			if(!data.data[0].tags) {
			  $('.tags-div').css('display','none');
			} else {
			  $('.tags-div').css('display','block');
			}

			if (!changepic || typeof changepic == undefined) {
			  $('#imageModal').modal('toggle');
			}

			document.addEventListener("keydown", keypressHandler, false);
			var onloadImageModal = function() {
				$('.wmg-photo-loader').addClass('hide')
				$('.image-modal-pic').removeClass('progressive-thumbnail');

				$('.wmg-photo-loader-inside').css('display','none');
			}

			var image = new Image();
			var source = angular.copy($scope.contentUrl.replace('%%', '40'));
			image.src = angular.copy(source);

			if (index == 0) {
			  $('#imageModal').find('.left-arrow').addClass('hide');
			} else if (index == ($rootScope.imagesArray.length - 1)) {
			  $('#imageModal').find('.right-arrow').addClass('hide');
			}

			image.onload = function() {
			  //image.classList.add('loaded');
				// if(history.pushState && history.replaceState){
        //     url = "/photos/" + pic._source.image_id;
        //     $rootScope.imageFlag = 1;
        //     history.pushState({"id": pic._source.image_id}, "", url);
      	// }

				$('.image-modal-pic').addClass('progressive-thumbnail')
				$('.wmg-photo-loader').addClass('hide')

				var largeImage = new Image();
				var newSource = angular.copy($scope.contentUrl.replace('%%', '800'));
				largeImage.src = angular.copy(newSource);
				if (largeImage.complete) {
					onloadImageModal(); // checks if image is in cache, sometimes onload function does not work
				}

				largeImage.onload = function() {
					$scope.contentUrl = encodeURI(newSource).replace("(", "%28").replace(")", "%29");
					$scope.$digest();
					//$('.image-modal-pic').removeClass('progressive-thumbnail');
					onloadImageModal();

				}
			}
		});
	}

	function get_before_after_images(id){
		$scope.thumbsArray = [];
		var cnt = 0;
		//get index of the opened image
		var localpostArrayItems = $scope.postArrays.items;
		// console.log(localpostArrayItems);
		indexes = $.map(localpostArrayItems, function(obj, index){
			if(obj._source.image_id == id){
				return index;
			}
		});
		// console.log(indexes[0]);
		if(indexes[0] >= 0){
			for(i = indexes[0]; i >= (indexes[0] - 3); i--){
				if(localpostArrayItems[i] != undefined){
					// console.log(localpostArrayItems[i]);
					localpostArrayItems[i]['_source']['image_url'] = localpostArrayItems[i]['_source']['image_url'].replace("%%", "80");
					$scope.thumbsArray.unshift(localpostArrayItems[i]);
					cnt++;
				}
				else{
					break;
				}
			}
			var l = $scope.thumbsArray.length;
			for(i = indexes[0] + 1; i <= (indexes[0] + 8 - l); i++){
				if(localpostArrayItems[i] != undefined){
					localpostArrayItems[i]['_source']['image_url'] = localpostArrayItems[i]['_source']['image_url'].replace("%%", "80");;
					$scope.thumbsArray.push(localpostArrayItems[i]);
				}
				else{
					break;
				}
			}
		}
	}

	$scope.toggleLove = function(pic) {
		if(localStorage.getItem('vendor_logged_in')) {
			$('#imageModal').modal('hide');
			openVendorError();
		} else if(!localStorage.getItem('logged_in')) {
			$('#imageModal').modal('hide');
			openLoginModal();
		} else {
			var data ={}
			data['content_id'] = pic.image_id;
			data['content_type'] = 1;
			if(localStorage.getItem('wedding_id')) {
				data['wedding_id'] = localStorage.getItem('wedding_id')
			}
			// console.log(data);
			toggleLovePost(config.token,data).then(function (success) {
				if(success.data.response.status) {
					pic.is_loved = 1;
					pic.love_count++;
				} else {
					pic.is_loved = 0;
					if(pic.love_count != 0) pic.love_count--;
				}
			},function(err) {
				console.log('err',err);
			});
		}
	}


  $scope.showModal = function (imageId,actualImageUrl) {
  	$scope.websiteUrl = '';
  	$scope.isLoved = '';
  	$scope.tags = [];
  	$scope.imageDetail={};
  	if(actualImageUrl.indexOf('%%') == -1) {
  		actualImageUrl = actualImageUrl.replace('270','%%');
  	}
  	$scope.imageUrl = actualImageUrl;
  	$timeout(function() {
  		$('#imageModal').modal('show');
	  	var windowHeight = $(window).height();
	  	var rightpHeight = windowHeight - 100;
	  	$('#imageModal').find('.modal-right-panel').css('height', rightpHeight + 'px');
	  	$('#imageModal').find('.image-modal-content').css('min-height', rightpHeight + 'px');
	  	$('#imageModal').find('.image-modal-content').find('img').css('max-height', rightpHeight + 'px');
	  	var diff = rightpHeight - $('#imageModal').find('.image-modal-content').find('img').height();
	  	$('#imageModal').find('.image-modal-content').find('img').css('margin-top', diff / 2);
		},500);
	  	imageDetail(imageId, config.token).success(function(data) {
		  	$scope.imageDetail = data.data;
		  	//console.log(data.data,$scope.imageDetail,"$scope.imageDetail");
		  	$scope.isLoved = $scope.imageDetail != undefined ? $scope.imageDetail[0].is_loved : '';
		  	$scope.imageId = $scope.imageDetail != undefined ? $scope.imageDetail[0].image_id : '';
		  	//console.log($scope.isLoved,"$scope.imageDetail");
		  	if ($scope.imageDetail && $scope.imageDetail[0].tagged_vendors[0] && $scope.imageDetail[0].tagged_vendors[0].websiteLink) {
		  	  $scope.websiteUrl = $scope.imageDetail[0].tagged_vendors[0].websiteLink;
		  	}
		  	if ($scope.imageDetail && $scope.imageDetail[0].tagged_vendors) {
			    for (var i = 0; i < $scope.imageDetail[0].tagged_vendors.length; i++) {
			      $scope.imageDetail[0].tagged_vendors[i].profile_pic_url = $scope.imageDetail[0].tagged_vendors[i].profile_pic_url.replace('%%', '40');
			    }
		  	}

		  	$scope.tags = [];

		  	console.log("At the Tags Part");
		  	if ($scope.imageDetail && $scope.imageDetail[0].tags) {
			    angular.forEach($scope.imageDetail[0].tags, function(value, key) {
			        if (value != '' && key != 'other_tags') {
			          $scope.tags.push(value);
			        }
			        if (key == 'other_tags' && key != '') {
			          var otherTagsArray = value.split(',');
			          $scope.tags.push.apply($scope.tags,otherTagsArray);
			        }
			    });
		  	}
			var k = 0;
		  	var $image = $('#imageModal').find('.image-modal').attr('ng-src');
			for( var i=0; i< $scope.postArrays.items.length;i++) {
				if (($scope.postArrays.items[i]._source.image_url.replace('%%','270') == $image) || ($scope.postArrays.items[i]._source.image_url.replace('%%','800') == $image)) {
					var k= i;
				}
		  	}
		  	if(!k) {
		  		$('#imageModal').find('.fa-chevron-left').css('display','none');
		  	} else {
		  		$('#imageModal').find('.fa-chevron-left').css('display','block');
		  	}
		  	if( k == ($scope.postArrays.items.length - 1 )) {
		  		$('#imageModal').find('.fa-chevron-right').css('display','none');
		  	} else {
		  		$('#imageModal').find('.fa-chevron-right').css('display','block');
		  	}
			})
			imageShare(imageId, config.token, 1).success(function(data) {
			$scope.imageShareValue = data.data;
			if ($scope.imageShareValue) {

				$scope.imageShareValue.shareText = $scope.imageShareValue.share_text ;
				$scope.imageShareValue.shareUrl = $scope.imageShareValue.share_url;
			}

		  //console.log('modaltest',data);

			})
  }
  $scope.loveit = function(image_id) {
  	var wedding_id = localStorage.getItem('wedding_id');

	  loveUnlove.loveit(config.token, image_id, 1, wedding_id).success(function() {
	      $scope.isLoved = true;
	      //scope.post.content.love_count++;
	      //$('.feed-heart').removeClass('fa-heart-o').addClass('fa-heart').addClass('pink-text');
	      $('.modal-heart').addClass('bg-pink');
	  });
  }

  $scope.unloveit = function(image_id) {
  	var wedding_id = localStorage.getItem('wedding_id');

    loveUnlove.unloveit(config.token, image_id, 1, wedding_id).success(function() {
        $scope.isLoved = false;
        //scope.post.content.love_count--;
        //element.find('.feed-heart').removeClass('fa-heart').removeClass('pink-text').addClass('fa-heart-o');
        $('.modal-heart').removeClass('bg-pink');
    });
	}


}]);
angular.bootstrap(document.getElementById("searchPost"), ['searchApp']);
